export default {
  filters: {
    sac_status_sac: 'Estado de atención',
    sac_status_other: 'Estado nuevo',
    names: 'Grupos',
    channels_listening: 'Canales de escucha',
    channels_proprietary: 'Canales propietarios',
    themes: 'Temas',
    pids: 'Publicaciones por id',
    genders: 'Género',
    polarities: 'Sentimiento',
    tags: 'Etiquetas',
    favorite: 'Publicaciones verificadas',
    dark_post: 'Tipo de publicación',
    sac_last_status: 'Estado anterior',
    sac_replier: 'Agentes',
    sac_type: 'Interacción',
    pages: 'Páginas',
    uids: 'Autores',
    contracts: 'Contrato',
    bots: 'Bot',
    category: 'Categoría',
  },
  selected: 'seleccionado',
  selectedPlural: 'seleccionados',
};
